import { THEME } from '@lyon/utils/theme/index';
import { ModalOverrides } from 'baseui/modal';
import { DARK_MUTED } from '@lyon/utils/theme/colors/darkmuted';

export const MODAL: ModalOverrides = {
  Dialog: {
    style: {
      backgroundColor: DARK_MUTED.darkmuted700,
      width: '25%',

      [THEME.media.small]: {
        width: '100%',
      },
    },
  },
};
